import * as React from "react";
import { forwardRef } from "react";
const StarSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { d: "m12 3 3.045 5.81 6.466 1.1-4.585 4.69.952 6.49L12 18.18l-5.878 2.91.951-6.49L2.49 9.91l6.466-1.1z" }));
const ForwardRef = forwardRef(StarSVG);
export default ForwardRef;
//# sourceMappingURL=Star.js.map